import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
const SKELETON_CLASSNAMES = 'w-full h-[50px] rounded-sm bg-gray-200 bg-linear-to-r from-gray-200 via-gray-100 to-gray-200 bg-[length:200%_100%] bg-left-top';
const ExpressCheckoutSectionSkeleton = () => {
  const $ = _c(7);
  const t = useTranslations("general.a11y");
  let t0;
  if ($[0] !== t) {
    t0 = t("loading");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div aria-hidden={true} className={SKELETON_CLASSNAMES} />;
    t2 = <div aria-hidden={true} className={SKELETON_CLASSNAMES} />;
    t3 = <div aria-hidden={true} className={SKELETON_CLASSNAMES} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t0) {
    t4 = <div className="expressCheckoutWrapper"><div className="expressCheckoutContainers" aria-busy={true} aria-label={t0}>{t1}{t2}{t3}</div></div>;
    $[5] = t0;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default ExpressCheckoutSectionSkeleton;